module.exports = __webpack_public_path__ + "img/blue-sea.4296e234.png";